import logger from '../../utils/logger';
import logError from '../../utils/logError';

import { compatibleVersions } from './compatibilityService';

export const CompatibilityMatrixService = {
  fetchMatrix: async (userPool) => {
    try {
      const result = await compatibleVersions(userPool);

      const matrix = result?.data || result;

      return matrix;
    } catch (error) {
      logger.error(logError(error, { action: 'fetchCompatibilityMatrix' }));
      throw error;
    }
  },
};
